<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Ano/Série
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                v-model="content.nome"
                label="Ano/Série"
                counter="25"
                maxlength="25"
                readonly
                outlined
                dense
              ></v-text-field>
              <v-textarea
                v-model="content.descricao"
                label="O que é esperado do aluno"
                counter="2500"
                maxlength="2500"
                readonly
                dense
                outlined
              ></v-textarea>
              <v-text-field
                v-model="content.modalidade.nome"
                label="Modalidade de Ensino"
                readonly
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-model="content.quantidadeBimestres"
                label="Quantidade de Bimestres"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Serie } from '~/commons/classes/serie';

export default {
  props: new DialogProps(Serie),
};
</script>
